import { render, staticRenderFns } from "./QuntiHuaxiangDetail.vue?vue&type=template&id=2a510a86&scoped=true&"
import script from "./QuntiHuaxiangDetail.vue?vue&type=script&lang=js&"
export * from "./QuntiHuaxiangDetail.vue?vue&type=script&lang=js&"
import style0 from "./QuntiHuaxiangDetail.vue?vue&type=style&index=0&id=2a510a86&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a510a86",
  null
  
)

export default component.exports